import React from 'react';

export function Card({ children, padding = 'md', interactive = false, accent, style, ...rest }) {
  const [hover, setHover] = React.useState(false);
  const pads = { none: 0, sm: 'var(--sp-4)', md: 'var(--sp-6)', lg: 'var(--sp-8)' };
  const accentColors = {
    blue: 'var(--y-blue)', neon: 'var(--y-neon)',
    build: 'var(--y-build)', secure: 'var(--y-secure)', support: 'var(--y-support)',
  };
  return (
    <div
      onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}
      style={{
        background: 'var(--bg-surface)', borderRadius: 'var(--radius-lg)',
        border: '1px solid var(--border-subtle)', padding: pads[padding] ?? pads.md,
        boxShadow: interactive && hover ? 'var(--shadow-md)' : 'var(--shadow-sm)',
        transform: interactive && hover ? 'translateY(-2px)' : 'none',
        transition: 'box-shadow var(--dur) var(--ease-out), transform var(--dur) var(--ease-out)',
        borderTop: accent ? `3px solid ${accentColors[accent] || accent}` : undefined,
        cursor: interactive ? 'pointer' : 'default', ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
}
